import React from 'react';
import { motion } from "framer-motion";
import { useIsMobile } from "@/hooks/use-mobile";

interface SearchResult {
  id: string;
  title: string;
  content: string;
  category: string;
  source?: string;
  sources?: string[];
}

interface SearchResultsProps {
  results: SearchResult[];
  onSaveSearch: (result: SearchResult) => void;
}

export const SearchResults: React.FC<SearchResultsProps> = ({ results, onSaveSearch }) => {
  const isMobile = useIsMobile();

  if (!results?.length) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.2 }}
      className="space-y-4"
    >
      {results.map((result) => (
        <div
          key={result.id}
          className="p-4 bg-white rounded-lg border shadow-sm hover:shadow-md transition-shadow"
        >
          <div className="flex flex-col gap-2">
            <h3 className="text-lg font-semibold text-gray-900">
              {result.title}
            </h3>
            
            <div className="flex flex-wrap gap-2">
              <span className="text-sm px-2 py-1 bg-orange-100 text-orange-800 rounded-full">
                {result.category}
              </span>
              {!isMobile && result.source && (
                <span className="text-sm text-gray-500">
                  Kilde: {result.source}
                </span>
              )}
            </div>

            <p className="text-gray-700 text-sm sm:text-base mt-2">
              {result.content}
            </p>

            {!isMobile && result.sources && result.sources.length > 0 && (
              <div className="mt-4 pt-4 border-t border-gray-100">
                <h4 className="text-sm font-medium text-gray-700 mb-2">Kilder:</h4>
                <ul className="text-sm text-gray-600 space-y-1">
                  {result.sources.map((source, index) => (
                    <li key={index}>{source}</li>
                  ))}
                </ul>
              </div>
            )}

            <button
              onClick={() => onSaveSearch(result)}
              className="mt-4 text-sm px-4 py-2 bg-orange-100 text-orange-800 rounded-md hover:bg-orange-200 transition-colors w-full sm:w-auto"
            >
              {isMobile ? "Lagre" : "Lagre søk"}
            </button>
          </div>
        </div>
      ))}
    </motion.div>
  );
};